
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { Draggable } from 'react-beautiful-dnd';

function AboutEdit({ dragHandleProps }) {
  const { t } = useTranslation();
  const apiUrl = process.env.REACT_APP_BACKEND_URL

  let userId = Cookies.get('userId');
  let UserToken = Cookies.get('UserSpecialToken');
  let LanguageSelected = Cookies.get('LanguageSelected');

  const [AboutModal, setAboutModal] = useState(false)
  const [EditAboutModal, setEditAboutModal] = useState(false)
  const [InputsErrors, setInputsErrors] = useState([])
  const [aboutInfo, setAboutInfo] = useState({
    en: '',
    fr: '',
    ar: ''
  })
  const [Done, setDone] = useState(false)
  const [AboutId, setAboutId] = useState()
  const [isFetching, setIsFetching] = useState(false);
  const [aboutContent, setAboutContent] = useState([])

  const SetAboutToUpdateDefaultValues = () => {
    const about = aboutContent[0];
    if (!about || !about.description) return;

    // Backend returns description as object now (via cast)
    const desc = about.description;
    setAboutInfo({
      en: desc?.en || '',
      fr: desc?.fr || '',
      ar: desc?.ar || ''
    });
    setAboutId(about.id);
  };

  useEffect(() => {
    if (AboutModal || EditAboutModal) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [AboutModal, EditAboutModal]);

  useEffect(() => {
    if (!userId) return;

    fetch(`${apiUrl}/GetAboutInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`
      },
      body: JSON.stringify({ user_id: userId })
    })
      .then(res => res.json())
      .then(result => {
        console.log('API Response:', result); // Debug log
        if (result.success && result.data) {
          console.log('Description:', result.data.description); // Debug log
          setAboutContent([result.data]);
        } else {
          setAboutContent([]);
        }
      })
      .catch(err => console.error('Fetch error:', err));
  }, [Done, userId, apiUrl, UserToken]);

  const StoreAboutInfo = (e) => {
    setIsFetching(true);
    e.preventDefault()

    fetch(`${apiUrl}/StoreAboutInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`
      },
      body: JSON.stringify({
        description: aboutInfo,
        user_id: userId
      })
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setAboutInfo({ en: '', fr: '', ar: '' })
          setDone(!Done)
          setInputsErrors([])
          setAboutModal(false)
          toast.success(result.message, {
            position: toast.POSITION.CENTER
          });
        } else {
          setInputsErrors(result.errors)
        }
      })
      .finally(() => {
        setIsFetching(false);
      });
  }

  const UpdateAboutInfo = (e) => {
    setIsFetching(true);
    e.preventDefault()

    fetch(`${apiUrl}/UpdateAboutInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`
      },
      body: JSON.stringify({ description: aboutInfo, aboutId: AboutId })
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setAboutInfo({ en: '', fr: '', ar: '' }) 
          setInputsErrors([])
          setDone(!Done)
          setEditAboutModal(false)
          toast.success(result.message, {
            position: toast.POSITION.CENTER
          });
        } else {
          setInputsErrors(result.errors)
        }
      })
      .finally(() => {
        setIsFetching(false);
      });
  }

  const DeleteAboutInfo = (e, id,lang) => {
    e.preventDefault()

    fetch(`${apiUrl}/DeleteAboutInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`
      },
      body: JSON.stringify({ aboutId: id,lang:lang })
    })
      .then(response => response.json())
      .then(result => {
      if (result.success) {
        const newAboutContent = aboutContent.map(a => {
          if (a.id === id) {
            return {
              ...a,
              description: { ...a.description, [lang]: '' } 
            };
          }
          return a;
        });
        setAboutContent(newAboutContent);
        toast.success(result.message, { position: toast.POSITION.CENTER });
      }
    });
  }

  const handleChange = (lang, value) => {
    setAboutInfo(prev => ({ ...prev, [lang]: value }));
  };

  return (
    <div className={`${LanguageSelected === 'ar' ? 'rtlDiv' : ''}`}>
      <section className="About sections rounded-xl pt-3 pb-3 pl-3 m-3">
        <div className='flex justify-between'>
          <div>
            <h1 className={`${LanguageSelected === 'ar' ? 'title title--h1 first-title title__separate text-theme right-4' : 'title left-0 title--h1 first-title title__separate text-theme'}`}>
              {t('À propos')}
            </h1>
          </div>

          
          {aboutContent.length > 0 && (
            <div className="flex gap-2">
              <button
                onClick={() => {
                  SetAboutToUpdateDefaultValues();
                  setEditAboutModal(true);
                }}
                className="text-blue-500 hover:text-blue-700"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
              </button>
              <button
                onClick={(e) => DeleteAboutInfo(e, aboutContent[0].id,LanguageSelected)}
                className="text-red-500 hover:text-red-700"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            </div>
          )}
        </div>

       
        {aboutContent.length > 0 && aboutContent.map(about => {
   
          const description = about.description || {};
          const displayText = description[LanguageSelected]  || '';

          return (
            <React.Fragment key={about.id}>
            <div className="text flex items-center m-2 p-1" key={about.id}>
              <p className="textaboutprofile">{displayText}</p>
            </div>
              {displayText=== "" &&(

              <a
                onClick={() => {
                  SetAboutToUpdateDefaultValues();
                  setEditAboutModal(true);
                }}
              >
                <main className="flex p-5 items-center justify-center">
              <label htmlFor="dropzone-file-about" className="mx-auto cursor-pointer flex w-full max-w-lg flex-col items-center rounded-xl border-2 border-dashed border-gold div-sections p-6 text-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <p className="mt-2 text-about tracking-wide">{t("Entrez vos informations 'À propos'.")}</p>
              </label>
            </main>
              </a>
           
       
              )}
</React.Fragment>
          );
        })}

        {/* Show add button when no content */}
        {aboutContent.length === 0 && (
          <a onClick={() => { setAboutModal(true) }}>
            <main className="flex p-5 items-center justify-center">
              <label htmlFor="dropzone-file-about" className="mx-auto cursor-pointer flex w-full max-w-lg flex-col items-center rounded-xl border-2 border-dashed border-gold div-sections p-6 text-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <p className="mt-2 text-about tracking-wide">{t("Entrez vos informations 'À propos'.")}</p>
              </label>
            </main>
          </a>
        )}

        <div className="drag-handle flex justify-center pt-2 text-theme" {...dragHandleProps}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
            <path fillRule="evenodd" d="M17.303 5.197A7.5 7.5 0 006.697 15.803a.75.75 0 01-1.061 1.061A9 9 0 1121 10.5a.75.75 0 01-1.5 0c0-1.92-.732-3.839-2.197-5.303zm-2.121 2.121a4.5 4.5 0 00-6.364 6.364.75.75 0 11-1.06 1.06A6 6 0 1118 10.5a.75.75 0 01-1.5 0c0-1.153-.44-2.303-1.318-3.182zm-3.634 1.314a.75.75 0 01.82.311l5.228 7.917a.75.75 0 01-.777 1.148l-2.097-.43 1.045 3.9a.75.75 0 01-1.45.388l-1.044-3.899-1.601 1.42a.75.75 0 01-1.247-.606l.569-9.47a.75.75 0 01.554-.68z" clipRule="evenodd" />
          </svg>
        </div>
      </section>

      {/* Add About Modal */}
      {AboutModal && (
        <div>
          <div className="minscreen h-full animated fadeIn faster fixed left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => { setAboutModal(false); setInputsErrors([]) }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full max-w-sm p-8 rounded-md">
              <h2 className="text-3xl mb-2 text-theme">{t('À propos')}</h2>
              <form className="space-y-6 text-about">
                <div>
                  <label htmlFor="phoneNumber" className="textModal">
                    {t("Présentez-vous, parlez de vos projets et de vos passions... C'est votre première impression (numérique) sur les personnes que vous rencontrez !")}
                  </label>
                  <div className="mt-5">
                    {LanguageSelected === 'en' && (
                      <textarea
                        value={aboutInfo.en}
                        onChange={(e) => handleChange('en', e.target.value)}
                        placeholder="Enter English description"
                        rows={4}
                        className="w-full p-2 mb-2 border rounded"
                      />
                    )}

                    {LanguageSelected === 'fr' && (
                      <textarea
                        value={aboutInfo.fr}
                        onChange={(e) => handleChange('fr', e.target.value)}
                        placeholder="Entrer la description en français"
                        rows={4}
                        className="w-full p-2 mb-2 border rounded"
                      />
                    )}

                    {LanguageSelected === 'ar' && (
                      <textarea
                        dir="rtl"
                        value={aboutInfo.ar}
                        onChange={(e) => handleChange('ar', e.target.value)}
                        placeholder="أدخل الوصف بالعربية"
                        rows={4}
                        className="w-full p-2 border rounded"
                      />
                    )}

                    {InputsErrors.description && (
                      <p className="mt-2 text-red-600 dark:text-red-500 text-sm">
                        {InputsErrors.description}
                      </p>
                    )}
                  </div>

               
                </div>
                <button
                  onClick={(e) => StoreAboutInfo(e)}
                  disabled={isFetching}
                  type="submit"
                  className={`w-full btn-edit ${isFetching ? 'opacity-50 cursor-not-allowed' : ''}`}
                >
                  {isFetching ? t('Chargement...') : t('enregistrer')}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Edit About Modal */}
      {EditAboutModal && (
        <div>
          <div className="forms-info minscreen h-full animated fadeIn faster fixed left-0 top-0 flex justify-center items-center inset-0 z-50">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => { setEditAboutModal(false); setInputsErrors([]) }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full max-w-sm p-8 rounded-md">
              <h2 className="text-3xl mb-2 text-theme">{t('À propos')}</h2>
              <form className="space-y-6 text-about">
                <div>
                  <label htmlFor="phoneNumber" className="textModal text-black">
                    {t("Présentez-vous, parlez de vos projets et de vos passions... C'est votre première impression (numérique) sur les personnes que vous rencontrez !")}
                  </label>
                  <div className="mt-5">
                    {LanguageSelected === 'en' && (

                      <textarea
                        value={aboutInfo.en}
                        onChange={(e) => handleChange('en', e.target.value)}
                        placeholder="Enter English description"
                        rows={4}
                        className="w-full p-2 mb-2 border rounded"
                      />
                    )}
                    {LanguageSelected === 'fr' && (

                      <textarea
                        value={aboutInfo.fr}
                        onChange={(e) => handleChange('fr', e.target.value)}
                        placeholder="Entrer la description en français"
                        rows={4}
                        className="w-full p-2 mb-2 border rounded"
                      />
                    )}

                    {LanguageSelected === 'ar' && (

                      <textarea
                        dir="rtl"
                        value={aboutInfo.ar}
                        onChange={(e) => handleChange('ar', e.target.value)}
                        placeholder="أدخل الوصف بالعربية"
                        rows={4}
                        className="w-full p-2 border rounded"
                      />)}
                    <p className="mt-2 text-red-600 dark:text-red-500">
                      <span className="font-xsmall">
                        {InputsErrors.hasOwnProperty('description') && InputsErrors.description}
                      </span>
                    </p>
                  </div>
                </div>
                <button
                  onClick={(e) => UpdateAboutInfo(e)}
                  disabled={isFetching}
                  type="submit"
                  className={`w-full btn-edit ${isFetching ? 'opacity-50 cursor-not-allowed' : ''}`}
                >
                  {isFetching ? t('Chargement...') : t('enregistrer')}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default AboutEdit